import asyncSessionLoader from "../../../../gd/data/async-session-loader"
import FinderTasksCollection from "../../../../model2/task/finder/collection"
import FinderTaskModel from "../../../../model2/task/finder/finder-task-model"
import {finderLoadRecentTasks} from "../../../finder/functions/load-recent-tasks"
import {SystemStatusFilter} from "../../../finder/task/@types"
import EntitySelectorItem from "../../glist/item"

// Same threshold the finders use -- one letter matches everything.
export const MIN_SEARCH_TEXT_LENGTH = 2

const debug = false
// const debug = "entitySelectorLoadTaskItems"

// Rows for the task list: the viewer's recent tasks, or the server's task search
// once they have typed enough. Both paths end in the same FinderTaskModel, so
// the list itself never learns which one it is showing.
export async function entitySelectorLoadTaskItems(search: string): Promise<EntitySelectorItem[]> {

    const tasks = search.length >= MIN_SEARCH_TEXT_LENGTH
        ? await searchTasks(search)
        : (await finderLoadRecentTasks()).rootModels

    debug && console.log(debug, 'loaded', search, tasks.length)

    // The glist's own `sortBy`/`defaultSortBy` (see `../../glist/module.ts`)
    // orders these by date, so the API's own order doesn't matter here.
    return _.map(tasks, taskToItem)
}

// `recent.tasks` is where the "last opened" moment lives -- the task payload has
// no such field, so a search hit the viewer has never opened shows no date.
function taskToItem(task: FinderTaskModel): EntitySelectorItem {
    return new EntitySelectorItem({
        entity      : task,
        title       : task.title,
        date        : gd.session.recent?.tasks?.get(task.id)?.date,
        projectId   : task.projectId,
    })
}

async function searchTasks(search: string): Promise<FinderTaskModel[]> {
    try {
        const response = await gd.api.Search.tasksV414(search, SystemStatusFilter.ALL).promise()

        await asyncSessionLoader(gd.session.findMissing({
            projects  : _.uniq(_.map(response.result, 'projectId')),
            taskTypes : _.uniq(_.map(response.result, 'taskTypeId'))
        }))

        return FinderTasksCollection.initFromJson(response.result).rootModels

    } catch (error: any) {
        debug && console.log(debug, 'search failed', error)
        return []
    }
}
